import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export type PanelType = 'main' | 'normal' | 'offline' | 'c' | 'd'


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoPanel',
  props: {
    type: { default: 'main' },
    borderless: { type: Boolean },
    transparentBg: { type: Boolean },
    hidenHeaderIcon: { type: Boolean },
    hasCorners: { type: Boolean },
    hasChart: { type: Boolean },
    highlight: { type: Boolean },
    highlightHeader: { type: Boolean },
    overflowHidden: { type: Boolean }
  },
  emits: ["click", "clickHeader"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'click', ev)
    (e: 'clickHeader', ev)
}), expose: any, slots: any, attrs: any }) {

const props = __props as { type: PanelType, borderless?: boolean, transparentBg?: boolean, hidenHeaderIcon?: boolean, hasCorners?: boolean, hasChart?: boolean, highlight?: boolean, highlightHeader?: boolean, overflowHidden?: boolean }





const borderlessReal = computed(() => {
    if (props.borderless) {
        return true
    }
    if (document.documentElement.classList.contains('light')) {
        return true
    }
    return false
})

const hasCornersReal = computed(() => {
    if (!props.hasCorners) {
        return false
    }
    if (document.documentElement.classList.contains('light')) {
        return false
    }
    return true
})


return { __sfc: true,props, emits, borderlessReal, hasCornersReal }
}

})